import moment from 'moment';

import { ApiService }      from '../../app-lite/api/api.service';
import { MessagesService } from '../../app-lite/messages/messages.service';

import MechanicSearchResultsHtml from '../mechanics/templates/mechanic.search.results.html';

export class SetUnavailableTimesCtrl {
  block : ng.blockUI.BlockUIService;

  list = [];

  mechanicSearchResultsTemplateUrl = MechanicSearchResultsHtml;

  Schedule : any;

  timesUnavailable = {
    endDate  : null,
    endTime  : null,
    mechanic : null,
    startDate: null,
    startTime: null
  };

  constructor (
    private $q                : ng.IQService,
    private $translate        : ng.translate.ITranslateService,
    private $uibModalInstance : ng.ui.bootstrap.IModalInstanceService,
    blockUI                   : ng.blockUI.BlockUIService,
    private messages          : MessagesService,
    private streamSearch      : any,
    private workshopAPI       : ApiService,
    Schedule                  : any
  ) {
    this.block    = blockUI.instances.get('unavailableTimesBlock');
    this.Schedule = new Schedule();
  }

  choose ( mechanic : any ) : void {
    this.timesUnavailable.mechanic = mechanic;
  }

  format ( mechanic : any ) : any {
    return angular.isObject(mechanic)
    ? mechanic.display_name
    : mechanic;
  }

  save ( unavailableAllDay = false ) : void {
    this.block.start();

    const unavailableTimes = [];

    const startDate = moment(this.timesUnavailable.startDate, 'YYYY-MM-DD');
    const endDate   = moment(this.timesUnavailable.endDate, 'YYYY-MM-DD');

    //Difference in number of days
    const totalDays = moment.duration(endDate.diff(startDate)).asDays() + 1;

    for ( let days = 0; days < totalDays; days++ ){
      const date = moment(this.timesUnavailable.startDate, 'YYYY-MM-DD').add(days, 'days');

      const unavailableEndTime   = unavailableAllDay
        ? moment(date.endOf('day').format('YYYY-MM-DD HH:mm'))
        : this.timesUnavailable.endTime;
      const unavailableStartTime = unavailableAllDay
        ? moment(date.startOf('day').format('YYYY-MM-DD HH:mm'))
        : this.timesUnavailable.startTime;

      const endTime = date
        .hour(moment(unavailableEndTime).hour())
        .millisecond(moment(unavailableEndTime).millisecond())
        .minute(moment(unavailableEndTime).minute())
        .second(moment(unavailableEndTime).second())
        .format('YYYY-MM-DDTHH:mm:ssZ');

      const startTime = date
        .hour(moment(unavailableStartTime).hour())
        .millisecond(moment(unavailableStartTime).millisecond())
        .minute(moment(unavailableStartTime).minute())
        .second(moment(unavailableStartTime).second())
        .format('YYYY-MM-DDTHH:mm:ssZ');

      unavailableTimes.push({
        date            : date.format('YYYY-MM-DD'),
        local_end_time  : endTime,
        local_start_time: startTime,
        mechanic_id     : this.timesUnavailable.mechanic.id,
        unavailableAllDay
      });
    }

    this.workshopAPI.post(this.Schedule.routes.saveUnavailable, { unavailable_times: unavailableTimes })
    .then(( response : any ) => {
      this.messages.show(this.$translate.instant(response.language_label), 'success');

      this.$uibModalInstance.close();
    })
    .catch(( err : any ) => {
      this.messages.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  selectTime ( event : Event, property : string ) : void {
    const picker = $(event.currentTarget).datetimepicker({
      initialDate : new Date(),
      showMeridian: true,
      startView   : 'day'
    })
    .on('changeDate', ( ev : any ) => {
      let date : string | Date = new Date(ev.date.valueOf());

      date = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes()
      ).toISOString();

      this.timesUnavailable[property] = date;

      $(picker).datetimepicker('hide');
    });

    $(picker).datetimepicker('show');
  }

  search ( typed : string ) : ng.IPromise<any> {
    return this.streamSearch.search('mechanics', typed)
    .then(( mechanics : Array<any> ) => this.$q.when(this.list.concat(mechanics)));
  }
}
